import { sessaoFetch, sessaoFetchLoading } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function list () {
  return sessaoFetch(`base`, `/instituicao/empresa?all=1`, 'GET')
}

export async function byProduto (produto) {
  return sessaoFetch(`base`, `/instituicao/empresa?all=1&produto_id=${produto}`, 'GET')
}

export async function cTabela () {
  return sessaoFetch(`base`, `/instituicao/tabela/comissionamento`, 'GET')
}

export async function cTabelaFiltro (dados) {
  return sessaoFetch(`base`, `/instituicao/tabela/comissionamento/filtro?` + serialize(dados), 'GET')
}

export async function cContrato (produto) {
  return sessaoFetch(`base`, `/instituicao/list/contrato?` + serialize(produto), 'GET')
}

export async function listFiltro (filtro) {
  return sessaoFetch(`base`, `/instituicao?all=1&nome=${filtro}`, 'GET')
}

export async function get (id) {
  return sessaoFetchLoading(`base`, `/instituicao/${id}/banco`)
}

export async function getInstituicoes (dados) {
  return sessaoFetchLoading(`base`, `/instituicao?` + serialize(dados), 'GET')
}

export async function add (dados) {
  return sessaoFetchLoading(`base`, `/instituicao/`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading(`base`, `/instituicao/${dados.id}`, 'PUT', dados)
}



// WEBPACK FOOTER //
// ./src/api/instituicao.js